<script>
export default {
  name: 'icon-text-edit',
  props: {
    color: {
      default: () => {
        return 'white'
      },
      type: String,
    },
  },
}
</script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36">
  <g id="グループ_12509" data-name="グループ 12509" transform="translate(-258 -561)">
    <g id="Ellipse_34" data-name="Ellipse 34" transform="translate(258 561)" fill="#fff" stroke="#dedede" stroke-width="1">
      <circle cx="18" cy="18" r="18" stroke="none"/>
      <circle cx="18" cy="18" r="17.5" fill="none"/>
    </g>
    <path id="Vector" d="M8.914,2.573,11.937,5.6,3.022,14.51H0V11.487Zm5.36.685L12.8,4.733,9.777,1.711,11.252.236a.8.8,0,0,1,1.136,0l1.886,1.886a.8.8,0,0,1,0,1.136Z" transform="translate(268.745 571.745)" fill="#00a5ee"/>
  </g>
</svg>
</template>
